export const TEAM = '3-3';

const BASE_URL = 'https://openmind-api.vercel.app/3-3';

export const URL = {
  BASE: BASE_URL,
  SUBJECT: `${BASE_URL}/subjects/`,
  QUESTION: `${BASE_URL}/questions/`,
  ANSWER: `${BASE_URL}/answers/`,
  DEPLOYED: '배포된 url',
};

export const API = {
  SUBJECT: URL.SUBJECT,
  QUESTION: URL.QUESTION,
  ANSWER: URL.ANSWER,
};
